import createCategoryAdapter from "./category.adapter";
import createBooksAdapter from "./books.adapter";
import createWikiAdapter from "./wiki.adapter";
import createBoclipsAdapter from "./boclips.adapter";
import createDatabaseAdapter from "./database.adapter";
import createAcademiaAdapter from "./academia.adapter";
import { databaseCategories } from "features/SourceSearch/data/search-fields.data";

export const getAdapter = ({ type, searchContext, params, user }) => {
  const { currentCategory } = searchContext || {};

  const {source, category, academiaSearch} = params;
  const isDatabaseCategory =
    source === "databases" &&
    databaseCategories.some(
      (database) =>
        database.key === currentCategory ||
        database.key === category ||
        database.label === category
    );

  const resolvedType =
    source === "books" ? "books" :
    source === "wiki" ? "wiki" :
    category === "boclips" ? "boclips" :
    isDatabaseCategory ? "database" :
    academiaSearch ? "academia" :
    type || "category";

  if (resolvedType === "books") return createBooksAdapter({ searchContext });
  if (resolvedType === "wiki") return createWikiAdapter({ searchContext, user });
  if (resolvedType === "boclips") return createBoclipsAdapter({ searchContext });
  if (resolvedType === "database") return createDatabaseAdapter({ searchContext, params });
  if (resolvedType === "academia") return createAcademiaAdapter({ searchContext, params });
  return createCategoryAdapter({ searchContext, params });
};
